import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { useState } from "react";
import { IGetServiceProps } from "@api/types/globalService.types";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";

export const useGetAllUsersService = ({
  page = "1",
  per_page = "15",
  enableQuery,
}: IGetServiceProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);

  const allUsersService = useQuery({
    queryKey: [...CACHE_KEYS.USERS, page, debouncedQuery, per_page],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.USERS,
        searchParams: {
          "filter[name]": debouncedQuery,
          page,
          per_page,
          include: "roles,partners,manager",
        },
      }),
    enabled: enableQuery,
  });

  return {
    services: { allUsersService },
    states: { searchQuery, setSearchQuery },
  };
};
